import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../utils/analytics'

/**
 * Hook to track page views on route changes
 * Automatically sends page_view event to GA4 when the route changes
 */
export function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    // Small delay to ensure the page title has updated
    const timer = setTimeout(() => {
      trackPageView(location.pathname, document.title)
    }, 100)

    return () => clearTimeout(timer)
  }, [location.pathname])
}

export default usePageTracking
